import type { SxProps, Theme } from '@mui/material/styles'

export const oiAnalysisDateTextFieldSx: SxProps<Theme> = {
    width: '100px',
    minWidth: '100px',
    maxWidth: '100px',
    '& .MuiOutlinedInput-root': {
        height: 32,
        fontSize: '0.875rem',
        color: 'inherit',
        padding: 0,
        '& fieldset': {
            borderColor: (theme) => theme.palette.background.default
        },
        '&:hover fieldset': {
            borderColor: (theme) => theme.palette.divider
        },
        '&.Mui-focused fieldset': {
            borderColor: (theme) => theme.palette.primary.main
        },
        '&.Mui-disabled': {
            '& fieldset': {
                borderColor: (theme) => theme.palette.background.default
            }
        }
    },
    '& .MuiOutlinedInput-input': {
        py: 0,
        px: 1,
        height: 32,
        boxSizing: 'border-box',
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
}

export const oiAnalysisDatePickerSlotProps = {
    textField: {
        size: 'small' as const,
        variant: 'outlined' as const,
        sx: oiAnalysisDateTextFieldSx
    }
}
